import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment/moment';
moment.locale('ja');

/**
 * Generated class for the TimestampFormatPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'timestampFormat',
})
export class TimestampFormatPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(timestamp: number, ...args) {
    return moment.unix(timestamp).format(args[0]);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date/timestamp-format.ts